import React from "react";
import CompaniesDescriptions from "../../components/companies/CompanyDescription";
import MainLayout from "../../layouts/MainLayout";
import Divisions from "./Divisions";

const ForagerMediaGroup = () => {
  return (
    <MainLayout styleNav={"bg-navy-blue"} showLogo={"hidden"} showIconBack={true}>
      <CompaniesDescriptions
        logo={require("../../assets/logos/logo-forager-media-group.png")}
        styleLogo="w-48"
        map={require("../../assets/img/companies/forager-media-group-map.png")}
        link={{
          name: "visit forager media group",
          href: "https://foragermediagroup.com/",
        }}
        description={
          <>
            <div className="flex flex-col gap-5 mb-20 2xl:mb-40">
              <h3 className="text-xl text-navy-blue font-medium">
                harvesting the best trends from around the world
              </h3>
              <p>
                Forager Media Group Canada launched in 2021. Since then it has
                developed into a provider of digital services in four distinct
                areas. Working with heritage organizations mostly in British
                Columbia, it has deepened the relationships with Forager
                partners there by taking part in the development of over 70
                projects across all four business divisions.
              </p>
              <p>
                Among the projects that Forager Media Group Canada has worked
                on, most have received federal, provincial, or regional support
                and recognition. Continuing to develop across Canada, Forager
                Media Group is taking collaboration in the tech and heritage
                sectors to new levels.
              </p>
            </div>
          </>
        }
      />
      <div className="bg-grey">
        <div className="bg-page-fmg bg-cover bg-no-repeat px-4">
          <Divisions />
        </div>
      </div>
    </MainLayout>
  );
};

export default ForagerMediaGroup;
